/**
 * 文件说明:
 *
 * pageMainContext
 *
 * ----------------------------------------
 * 创建用户: leo
 */
import {createContext, useContext} from 'react'

export const pageMainContext = createContext({
    getPageContainer: () => {},
})

export function usePageMainConfig() {
    return useContext(pageMainContext)
}
